$(function() {
    $('.js-form-page-login').validate({
        rules: {
            login: {
                email: true
            }
        },
        submitHandler: function(form) {
            $(form).find('[type="submit"]').prop('disabled', true).addClass('is-loading');

            form.submit();
        }
    });

    $('.js-form-lost-password').validate({
        submitHandler: function(form) {
            $(form).find('[type="submit"]').prop('disabled', true).addClass('is-loading');

            form.submit();
        }
    });
});